import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["eating-enough-to-train"]!;

export function Body() {
  return (
    <>
      <p>
        Running burns a lot of energy. When you eat too little compared with how much you
        train, it can affect both your health and your running. The International Olympic
        Committee updated its expert statement on this in 2023.
      </p>

      <h2>What the experts describe</h2>
      <p>
        The condition is called relative energy deficiency in sport, or REDs. It occurs when
        energy intake is too low for the training you do, so the body has too little left for
        its normal functions. It affects both women and men.
      </p>
      <p>
        Since the previous statement in 2018, more than 170 new studies have been published.
        The new statement points to a growing role of too little carbohydrate, to a link with
        mental health, and to more evidence about the effects in men. It also introduces a new
        clinical tool to help doctors detect and diagnose REDs.
      </p>

      <h2>What it means for you</h2>
      <p>
        Eat enough to support the training you do, especially in periods with more or harder
        training. Carbohydrate is an important part of that for runners.
      </p>
      <p>
        Warning signs that are worth taking seriously include missed or irregular periods,
        stress fractures, frequent illness, and fatigue or poor performance that doesn't improve
        with rest. If you recognise this, talk to a doctor. It can be treated, and it is better
        to act early.
      </p>

      <h2>What the statement can't tell you</h2>
      <p>
        The statement is aimed at doctors and sports organisations. It can't tell you how much
        you need to eat, and REDs is diagnosed by a doctor, not from a list of signs.
      </p>

      <h2>How we use it</h2>
      <p>
        PX7 Training doesn't give diet plans or weight goals. If training keeps feeling harder
        than it should, say so when the app asks how you feel, and talk to a doctor about it.
      </p>

      <h2>Source</h2>
      <ul>
        <li>
          Mountjoy et al. (2023), 2023 International Olympic Committee's (IOC) consensus
          statement on Relative Energy Deficiency in Sport (REDs).{" "}
          <a href="https://doi.org/10.1136/bjsports-2023-106994">British Journal of Sports Medicine</a>.
        </li>
      </ul>
    </>
  );
}
